import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  container: {
    gap: 16
  },
  title: {
    background: "#f0f0f0",
    height: 32,
    borderRadius: 2,
    padding: "4px 8px 4px 16px",
    gap: 8,
    display: "flex",
    alignItems: "center"
  },
  label: {
    fontWeight: "600 !important",
    fontSize: "12px !important",
    lineHeight: "16px",
    color: "#1E1E1E",
    letterSpacing: "0%",
    fontFamily: "Segoe UI !important"
  },
  content: {
    padding: theme.spacing(2, 2, 0, 2),
    gap: theme.spacing(2)
  },
  actions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center"
  }
}));

interface SectionProps {
  name: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({
  name,
  actions,
  children
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Typography className={classes.label}>{name}</Typography>
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
};
